import { render } from "./AccountDeleteConfirm.vue?vue&type=template&id=67f76491"
import script from "./AccountDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./AccountDeleteConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/AccountDeleteConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67f76491"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67f76491', __exports__)) {
    api.reload('67f76491', __exports__)
  }
  
  module.hot.accept("./AccountDeleteConfirm.vue?vue&type=template&id=67f76491", () => {
    api.rerender('67f76491', render)
  })

}


export default __exports__